import graphql from "babel-plugin-relay/macro";

export default graphql`
  query getEmailTemplatefieldsQuery($id: ID!) {
    hyblastEditor(id:$id) {
      fields{
        id
        label
        type
        value
        field
      }
      templateId
      id
      name
      subject
      lastTestEmails
      lastTestPhones
      rawMacrosHtml
      substitutedMacrosHtml
    }
  }
`;
